export default __webpack_public_path__ + "static/media/watermark.82bd9668.svg";